import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

var language = localStorage.getItem('Language')
var account_labels = JSON.parse(localStorage.getItem('user'))

if(account_labels && account_labels.organization && account_labels.organization.labels){

    account_labels = JSON.parse(
        account_labels.organization.labels
    )
}

if(account_labels && account_labels.agencies && account_labels.agencies.change){
    if(language && language=='en'){
        var custom_agencies = account_labels.agencies.en
        var custom_clients = account_labels.clients.en
    }else if(language && language=='ar'){
        var custom_agencies = account_labels.agencies.ar
        var custom_clients = account_labels.clients.ar
    }else{
        var custom_agencies = account_labels.agencies.fr
        var custom_clients = account_labels.clients.fr
    }
}else{
    var custom_agencies = "Menu.Businesses"
    var custom_clients = "Menu.Customers"
}

export const router = new Router({
    mode: 'history',
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
    base: process.env.BASE_URL,
    routes: [
        // ======================
        // Blank Layout
        // ======================    
        {
            path: '',
            component: () => import('../layout/blank/Blank.vue'),
            // ======================
            // Theme routes / pages
            // ======================
            children: [{
                path: '/',
                redirect: '/login',
                meta:{
                    authRequired: false
                }
            }, {
                path: '/login',
                name: 'Login',
                index: 1,
                meta:{
                    authRequired: false,
                    authorize: ['*'],
                    membership: ['*']
                },
                component: () => import('../views/authentication/Login.vue')
            }, {
                path: '/error404',
                name: 'Error 404',
                index: 2,
                meta:{
                    authRequired: false,
                    authorize: ['*'],
                    membership: ['*']
                },
                component: () => import('../views/authentication/Error404.vue')
            },{
                path: '/privacy',
                name: 'Privacy Policy',
                index: 4,
                meta:{
                    authRequired: false,
                    authorize: ['*'],
                    membership: ['*']
                },
                component: () => import('../views/authentication/Privacy.vue')
            }, {
                path: '/terms',
                name: 'Terms & Conditions',
                index: 5,
                meta:{
                    authRequired: false,
                    authorize: ['*'],
                    membership: ['*']
                },
                component: () => import('../views/authentication/Terms.vue')
            },
            ]
        },
        {
            // ======================
            // Full Layout
            // ======================
            path: '',
            component: () => import('../layout/full/MainContainer.vue'),
            // ======================
            // Theme routes / pages
            // ======================
            children: [{
                    path: '/dashboard',
                    name: 'Menu.Dashboard',
                    index: 1,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                        {
                            title: 'Menu.Dashboard',
                            active: true
                        },
                        ],
                    },
                    component: () => import('../views/dashboard/Index.vue')
                },
                {
                    path: '/customers',
                    name: custom_clients,
                    index: 2,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                        {
                            title: custom_clients,
                            active: true
                        },
                        ],
                    },
                    component: () => import('../views/customers/Index.vue')
                },
                {
                    path: '/feedbacks',
                    name: 'Menu.Feedback',
                    index: 3,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                        {
                            title: 'Menu.Feedback',
                            active: true
                        },
                        ],
                    },
                    component: () => import('../views/feedbacks/Index.vue')
                },
                {
                    path: '/sms',
                    name: 'Menu.SettingsSms',
                    index: 4,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.SettingsSms',
                                active: true
                            }
                        ]
                    },
                    component: () => import('../views/sms/Index.vue')
                },
                {
                    path: '/agencies',
                    name: custom_agencies,
                    index: 5,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: custom_agencies,
                                active: true
                            }
                        ]
                    },
                    component: () => import('../views/businesses/Index.vue')
                },
                {
                    path: '/agencies/:id/update',
                    name: 'Businesses.UpdateBusinessVue.Title',
                    index: 6,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: custom_agencies,
                                url: '/agencies'
                            },
                            {
                                title: 'Businesses.UpdateBusinessVue.Title',
                                active: true
                            }
                        ]
                    },
                    component: () => import('../views/businesses/Update.vue')
                },
                {
                    path: '/agencies/:id/show',
                    name: custom_agencies,
                    index: 7,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: custom_agencies,
                                url: '/agencies'
                            },
                            {
                                title: 'Businesses.UpdateBusinessVue.Title',
                                active: true
                            }
                        ]
                    },
                    component: () => import('../views/businesses/Show.vue')
                },
                {
                    path: '/agencies/create',
                    name: 'Businesses.CreateBusinessVue.Title',
                    index: 8,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: custom_agencies,
                                url: '/agencies'
                            },
                            {
                                title: 'Businesses.CreateBusinessVue.Title',
                                active: true
                            }
                        ]
                    },
                    component: () => import('../views/businesses/Create.vue')
                },
                {
                    path: '/settings/organization',
                    name: 'Menu.SettingsOrganization',
                    index: 9,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.SettingsOrganization',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/settings/Organization.vue')
                },
                {
                    path: '/settings/kiosk',
                    name: 'Menu.SettingsKiosk',
                    index: 10,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.SettingsKiosk',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/settings/Kiosk.vue')
                },
                {
                    path: '/settings/display',
                    name: 'Menu.SettingsDisplay',
                    index: 11,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.SettingsDisplay',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/settings/Display.vue')
                },
                // {
                //     path: '/settings/services',
                //     name: 'Menu.SettingsServices',
                //     index: 16,
                //     meta: {
                //         authRequired: true,
                //         authorize: ['*'],
                //         membership: ['*'],
                //         breadcrumb: [
                //             {
                //                 title: 'Menu.SettingsServices',
                //                 active: true
                //             },
                //         ],
                //     },
                //     component: () => import('../views/settings/Services.vue')
                // },
                {
                    path: '/settings/team',
                    name: 'Menu.SettingsTeam',
                    index: 10,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.SettingsTeam',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/settings/Team.vue')
                },
                {
                    path: '/settings/forms',
                    name: 'Menu.SettingsForms',
                    index: 14,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.SettingsForms',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/settings/Forms.vue')
                },
                {
                    path: '/settings/survey-result',
                    name: 'Menu.SettingsSurveyResult',
                    index: 15,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.SettingsSurveyResult',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/settings/SurveyResult.vue')
                },
                {
                    path: '/settings/form/:id/show',
                    name: 'Menu.SettingsFormShow',
                    index: 15,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.SettingsForms',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/settings/FormVisibility.vue')
                },
                {
                    path: '/settings/ticket',
                    name: 'Menu.SettingsTicket',
                    index: 11,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.SettingsTicket',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/settings/Ticket.vue')
                },
                {
                    path: '/settings/terms',
                    name: 'Menu.SettingsTerms',
                    index: 11.6,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.SettingsTerms',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/settings/Terms.vue')
                },
                {
                    path: '/settings/policy',
                    name: 'Menu.SettingsPolicy',
                    index: 11.7,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.SettingsPolicy',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/settings/Policy.vue')
                },
                {
                    path: '/statistics',
                    name: 'Menu.Statistics',
                    index: 12,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.Statistics',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/statistics/Index_new.vue')
                },
                {
                    path: '/profile',
                    name: 'Menu.Profile',
                    index: 13,
                    meta: {
                        authRequired: true,
                        authorize: ['*'],
                        membership: ['*'],
                        breadcrumb: [
                            {
                                title: 'Menu.Profile',
                                active: true
                            },
                        ],
                    },
                    component: () => import('../views/profile/Index.vue')
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/Error404'
        }
    ]
})

import NProgress from 'nprogress';

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const userLoggedIn = JSON.parse(localStorage.getItem('user'));

    if (to.meta.authRequired && !(userLoggedIn)) {
        if(!userLoggedIn) { localStorage.setItem('user', null) }
        return next('/login');
    }
    if ( to.fullPath=='/login' && userLoggedIn ) {
        if(!userLoggedIn) { localStorage.setItem('user', null) }
        return next('/dashboard');
    }
    if(userLoggedIn && !(to.meta.authorize.find((obj) => obj == userLoggedIn.user.role) || to.meta.authorize.find((obj) => obj == '*'))){
        return next('/Error404');
    }
    next();
})

router.beforeResolve(async(to, from, next) => {
    if (to.name) {
        // Start the route progress bar.
        NProgress.start()
    }
    next()
})

router.afterEach(() => {
    // Complete the animation of the route progress bar.
    NProgress.done()
})
export default router